import gql from 'graphql-tag';

export const GET_ADDITIONAL_SERVICES_BY_STORE_CODE = gql`
  query additionalServices($storeCode: String!) {
    store {
      additionalServices(storeCode: $storeCode) {
        code
        iconUrl
        link
        name
      }
    }
}`;

export const GET_STORE_DETAILS = gql`
  query StoreByCodeStoreDetailPage(
    $storeCode: String!
    $month: String!
    $dayOfWeek: String
    $sourceLatitude: Float
    $sourceLongitude: Float
  ) {
    store {
      byCode(
        storeCode: $storeCode
        sourceLatitude: $sourceLatitude
        sourceLongitude: $sourceLongitude
      ) {
        address {
          country {
            isocode
          }
          line1
          town
          phone
          region {
            isocodeShort
          }
          postalCode
        }
        baseStore
        rating {
          cleanlinessRating
          knowledgeRating
          numberOfReviews
          rating
          recommendedCount
          recommendedPercentage
        }
        reviewsSummary {
          rating
          count
        }
        code
        storeContent
        distance
        features {
          iconName
          name
          description
          code
        }
        largeImages: images(format: "large") {
          altText
          url
        }
        mediumImages: images(format: "medium") {
          altText
          url
        }
        smallImages: images(format: "small") {
          altText
          url
        }
        legacyStoreCode
        geoPoint {
          latitude
          longitude
        }
        managerName
        weekDays {
          holidayType
          name
          comment
          closed
          closingTime {
            formattedHour
            hour
            minute
          }
          formattedDate
          openingTime {
            formattedHour
            hour
            minute
          }
        }
        popularTimes(month: $month, dayOfWeek: $dayOfWeek) {
          peakHourData {
            hourOfDay
            peakTimesData {
              avgWaitTime
              median
              percentile75
              mean
              message
              stdDev
              n
              percentile25
            }
          }
          dayOfWeek
        }
        currentTime
      }
    }
    services(storeCode: $storeCode) {
      name
    }
  }
`;

export const GET_STORE_CMS_PAGE = gql`
  query storeDetailCMSPage($id: String!) {
    cms {
      page(siteId: "discountTire", id: $id) {
        documentTitle
        metaTags {
          name
          content
        }
        breadcrumbs {
          name
          url
        }
        contentSlots {
          position
          name: id
          cmsComponents {
            name
            ... on CmsHtmlComponent {
              html
            }
          }
        }
      }
    }
  }
`;

export const GET_STORE_REVIEWS = gql`
  query storeReviews($storeCode: String!, $q: String, $page: Int) {
    store {
      byCode(storeCode: $storeCode) {
        code
      }
      reviews(storeCode: $storeCode, q: $q, page: $page) {
        pagination {
          currentPage
          numberOfPages
          totalNumberOfResults
        }
        facets {
          code
          values {
            code
            count
          }
        }
        sorts {
          code
          selected
        }
        results {
          id
          averageRating
          reviewText
          recommended
          userDisplayName
          submissionDate
          helpfulCount
          notHelpfulCount
          answers {
            key
            value
          }
          storeCode
        }
      }
    }
  }
`;

export const GET_NEARBY_STORES = gql`
  query nearByStores($storeCode: String!) {
    store {
      nearByStores(storeCode: $storeCode) {
        address {
          line1
          town
          phone
          region {
            isocodeShort
          }
          postalCode
        }
        baseStore
        code
        description
        displayName
        distance
        legacyStoreCode
        geoPoint {
          latitude
          longitude
        }
        pitPass
        rating {
          cleanlinessRating
          knowledgeRating
          numberOfReviews
          rating
        }
        url
      }
    }
  }
`;

export const GET_PROMOTIONS = gql`
  {
    cms {
      page(id: "homepage") {
        contentSlots {
          position
          cmsComponents {
            __typename
            ... on CmsPromotionCarouselSectionComponent {
              id
              name
              position
              typeName
              cmsComponents {
                id
                name
                typeName
                startDate
                endDate
                image {
                  url
                  altText
                }
                seeProductsLink {
                  href
                  target
                  text
                }
                seeDetailsLink {
                  href
                  target
                  text
                }
              }
            }
          }
        }
        source
      }
    }
  }
`;
